<template>
  <div
    v-fixed="{fixed, top}"
    class="tab-nav"
  >
    <div
      v-if="newDataKeys && newDataKeys.length"
      ref="tabNav"
      class="nav-wrap"
    >
      <ul
        ref="navBar"
        class="nav-bar clearfix"
        :class="{'scroll-nav': maxDis > 0}"
      >
        <template v-for="(item) in newData">
          <li
            :key="item.fieldkey"
            v-anchor="{ anchorId: isAnchor ? item.fieldkey : '', top: -20 }"
            :class="{'active': item.fieldkey === currSelected, 'hide': !item.show}"
            @click="handleChangeTab(item.fieldkey, $event)"
          >
            {{ item.fieldname }}
          </li>
        </template>
      </ul>
      <slot />
      <i
        v-if="maxDis > 0"
        class="iconfont iconleft left-btn"
        :class="{'disabled-btn': scrollX >= 0}"
        @click="handleLeft"
      />
      <i
        v-if="maxDis > 0"
        class="iconfont iconicon-test14 right-btn"
        :class="{'disabled-btn': scrollX <= -maxDis}"
        @click="handleRight"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { anchor, fixed } from '@/lib/directives'
import BScroll from 'better-scroll'
import _ from 'lodash'

export default {
  name: 'TabNav',
  directives: { anchor, fixed },
  props: {
    data: {
      type: [Array, Object],
      default: () => ({})
    },
    isAnchor: {
      type: Boolean,
      default: false
    },
    selected: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      newData: [],
      timer: null,
      currSelected: this.selected,
      clickTab: false,
      scrollTimer: null,
      scrollStart: 0,
      scrollX: 0,
      maxDis: 0
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['isDeal']),
    ...mapState('inquery/relateData', [
      'isInvalid',
      'isDiscard'
    ]),
    ...mapGetters('inquery/detailData', ['permissionInfo', 'memberInfo']),
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    newDataKeys () {
      let arr = []
      for (let key in this.newData) {
        if (this.newData[key].show) {
          arr.push(this.newData[key])
        }
      }
      return arr.map(item => item.fieldkey)
    }
  },
  watch: {
    selected (val) {
      this.currSelected = val
    },
    data (val) {
      this.newData = this.setNewData()
      if (val) {
        this.timer = setTimeout(this.setNavWidth, 200)
      }
    },
    isDeal () {
      this.newData = this.setNewData()
      this.timer = setTimeout(this.setNavWidth, 200)
    },
    isInvalid () {
      this.newData = this.setNewData()
      this.timer = setTimeout(this.setNavWidth, 200)
    },
    isDiscard () {
      this.newData = this.setNewData()
      this.timer = setTimeout(this.setNavWidth, 200)
    },
    newDataKeys (val) {
      if (val.length) {
        this.initScroll()
        this.getMaxDis()
      }
    }
  },
  created () {
    if (this.$route.name === 'ClueDetail') {
      this.newData = this.setNewData()
      this.timer = setTimeout(this.setNavWidth, 200)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollTap)
  },
  destroyed () {
    clearTimeout(this.timer)
    window.removeEventListener('scroll', this.scrollTap)
  },
  methods: {
    setNewData () {
      let data = JSON.parse(JSON.stringify(this.data))
      for (let i in data) {
        let item = data[i]
        if (item.child && item.child.length) {
          this.$set(item, 'show', !(i === 'info' && (this.$route.name === 'ClueDetail')))
        }
      }

      if (!this.isDeal && data.deal_info) {
        this.$set(data.deal_info, 'show', false)
      }
      if (!this.isInvalid && data.invalid_info) {
        this.$set(data.invalid_info, 'show', false)
      }
      if (!this.isDiscard && data.discard_info) {
        this.$set(data.discard_info, 'show', false)
      }
      if (data['reception_info']) {
        data['reception_info'].show = false
      }
      return data
    },
    initScroll () {
      this.$nextTick(() => {
        if (!this.scroll && this.$refs.tabNav) {
          this.scroll = new BScroll(this.$refs.tabNav, {
            click: true,
            scrollX: true,
            scrollY: false,
            probeType: 2,
            mouseWheel: {
              speed: 20,
              invert: false,
              easeTime: 300
            },
            scrollStart: () => {
            // console.log(111)
            // _this.setNavWidth()
            /* if () {
              _this.disable()
            } */
            }
          })
          this.$refs.tabNav.addEventListener('wheel', (e) => {
            e.stopPropagation()
            /* if (!this.fixed) {
              this.scroll.disable()
            } */
          })
          this.scroll.on('scroll', (pos) => {
            // console.log(pos)
            /* if (!this.fixed) {
              this.scroll.disable()
            } */
            this.scrollX = Math.round(pos.x)
          })
        } else if (this.scroll) {
          this.scroll.refresh()
        }
      })
    },
    getMaxDis () {
      this.$nextTick(() => {
        let $navBar = this.$refs.navBar
        let parentWidth = $navBar.parentElement.offsetWidth
        this.maxDis = $navBar.offsetWidth - parentWidth - 40
      })
    },
    handleChangeTab (k) {
      this.$emit('change', k)
      // if (!this.fixed) return

      let newData = {}
      for (let k in this.newData) {
        if (this.newData[k].show) {
          newData[k] = this.newData[k]
        }
      }
      this.clickTab = true

      // 点击导航时，菜单自动上一个或下一个
      let $navBar = this.$refs.navBar
      let oldIndex = Object.keys(newData).findIndex(item => item === this.selected)
      let newIndex = Object.keys(newData).findIndex(item => item === k)
      let $li = []
      let children = $navBar.children
      for (let i = 0; i < children.length; i++) {
        let item = children[i]
        if (item.className.indexOf('hide') === -1) {
          $li.push(item)
        }
      }
      // console.log(oldIndex, newIndex)
      // let parentWidth = $navBar.parentElement.offsetWidth
      // let maxDis = $navBar.offsetWidth - parentWidth - 40
      let maxDis = this.maxDis

      if (oldIndex === -1 || newIndex === -1) return

      let dis = Math.abs($li[oldIndex].offsetLeft - $li[newIndex].offsetLeft)

      if (oldIndex > newIndex) {
        if (this.scroll.absStartX >= 0) return

        if (dis > Math.abs(this.scroll.absStartX)) {
          dis = Math.abs(this.scroll.absStartX)
        } else if (dis > maxDis) {
          dis = maxDis
        }
      } if (oldIndex < newIndex) {
        if (Math.abs(this.scroll.absStartX) >= maxDis) return
        if (dis - Math.abs(this.scroll.absStartX) >= maxDis) {
          dis = maxDis
        }
        dis = -dis
      }

      this.scrollX = dis
      this.scroll.scrollBy(dis, 0)
    },
    setNavWidth () {
      let $navBar = this.$refs.navBar
      if ($navBar && $navBar.children && $navBar.children.length) {
        let sum = _.reduce($navBar.children, (res, item) => {
          res += (item.offsetWidth + 25)
          return res
        }, 0)
        $navBar.style.width = sum + 'px'
      }
    },

    scrollTap (res) {
      clearTimeout(this.scrollTimer)
      if (document.querySelector('form') && this.auditStatus !== 1) {
        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        this.scrollTimer = setTimeout(this.scrollOver, 500)
        this.scrollStart = scrollTop
        const { children: aLi } = document.querySelector('form')
        Array.from(aLi).forEach(item => {
          if (scrollTop >= item.offsetTop && scrollTop < item.offsetTop + item.clientHeight) {
            const { key } = item.dataset
            if (!this.clickTab) {
              // console.log('move tab', key)
              this.currSelected = key || this.currSelected
              // todo
            }
          }
        })
      }
    },
    scrollOver () {
      let scrollEnd = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      if (this.scrollStart === scrollEnd) {
        // console.log('scroll end')
        this.clickTab = false
      }
    },
    handleLeft () {
      this.scrollEvent('left')
    },
    handleRight () {
      this.scrollEvent('right')
    },
    scrollEvent (direction) {
      let $navBar = this.$refs.navBar
      let dis = this.scrollX || 0
      let parentWidth = $navBar.parentElement.offsetWidth
      // let maxDis = $navBar.offsetWidth - parentWidth - 40
      let maxDis = this.maxDis
      let $li = []
      let children = $navBar.children
      for (let i = 0; i < children.length; i++) {
        let item = children[i]
        if (item.className.indexOf('hide') === -1) {
          $li.push(item)
        }
      }
      let len = $li.length
      let moveDis = Math.round(parentWidth / len)
      // console.log($navBar.offsetLeft, dis)

      if (direction === 'right') {
        dis = dis - moveDis
        if (Math.abs(dis) >= maxDis) {
          dis = -maxDis
        }
      } else {
        // if (dis >= 0) return
        dis = dis + moveDis
        if (dis >= 0) {
          dis = 0
        }
      }

      this.scrollX = dis
      this.scroll.scrollTo(dis, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-nav {
  position: relative;
  height: 48px;
  z-index: 990;
  .nav-hidden {
    overflow: hidden;
  }
  .left-btn, .right-btn {
    position: absolute;
    top: 0;
    z-index: 3;
    height: 48px;
    width: 24px;
    padding: 16px 0;
    color: #ccc;
    font-size: 16px;
    cursor: pointer;
    background-color: #fff;
  }
  .left-btn {
    left: 0;
  }
  .right-btn {
    right: 0;
    text-align: right;
  }
  .disabled-btn {
    color: #e5e5e5;
  }
  .nav-wrap {
    // fixed or absolute
    position: absolute;
    width: 100%;
    height: 48px;
    background-color: #fff;
    overflow: hidden;
  }
  .nav-bar {
    position: relative;
    top: 1px;
    z-index: 2;
    // width: 9999px;
    height: 48px;
    &.scroll-nav {
      padding: 0 24px;
    }
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
